<template>
	<v-card id="assigned_tree_selection" elevation="0" color="transparent" @click.stop>
		<v-text-field
			style="position: relative"
			:color="color"
			:background-color="bgColor"
			:outlined="outlined"
			:placeholder="placeholder"
			:error="error"
			v-model="search_key"
			dense
			hide-no-data
			hide-details
			rows="1"
			auto-grow
			:readonly="loading"
			:disabled="disabled"
			@click.stop="queryAssigned"
			@input="inviteesQuery" 
		>
			<template v-slot:append>
				<v-icon v-if="search_key.length !== 0" small :disabled="disabled" style="margin-top: 4px;" @click="remove()">mdi-close</v-icon>
				<div v-if="loading" class="load"></div>
			</template>
		</v-text-field>
		<v-card-text v-if="!close_all && is_open && search_key.length === 0" class="pa-0 tree-container tree-wrap" :style="`width: ${maxWidth}px;top: ${top}px;left: ${left}px;`">
			<div class="tree-wrap-container">
				<v-treeview
					v-model="assigned_to"
					:items="assign_items"
					:color="color"
					:selected-color="color"
					:open.sync="open"
					:active="selected"
					selectable
					multiple-active
					activatable
					return-object
					open-on-click
					hoverable
					dense
					expand-icon="mdi-chevron-down"
					@update:active="onTreeviewNoteActive($event)"
				>
					<template v-slot:label="{ item }">
						<v-row class="mx-0 my-1" :align="'center'">
							<span>{{ item.name }}</span>
						</v-row>
					</template>
				</v-treeview>
			</div>
		</v-card-text>
		<v-card-text v-if="!close_all && !is_open && search_key.length !== 0" class="pa-0 tree-container tree-wrap" :style="`width: ${maxWidth}px;top: ${top}px;left: ${left}px;`">
			<div class="tree-wrap-container">
				<v-list-item v-for="item in invitees_items" :key="item.employee.id" dense>
					<v-row align-self="center" class="mt-0">
						<v-col cols="2">
							<v-checkbox
								class="ma-0 pa-0"
								v-model="assigned_to"
								:value="item"
								:color="color"
								dense
								hide-details
								@click.stop
							></v-checkbox>
						</v-col>
						<v-col cols="1" class="px-0">
							<v-user-avatar
								size="24"
								class="text-caption text-decoration-none"
								:code="item.name"
								:image="`/api/addressbook/${item.employee.id}/image.png`"
							/>
						</v-col>
						<v-col cols="9" class="pr-0">
							<v-row class="ma-0" align="center">
								<div>
									<div class="item-text">{{ item.employee.display_name }}</div>
									<div class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px;">{{ item.employee.email }}</div>
								</div>
								<v-chip v-if="item.freelancer" color="info" x-small class="ml-1">Freelancer</v-chip>
							</v-row>
						</v-col>
					</v-row>
				</v-list-item>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;
const CLIENT = 3;
const FREELANCER = 4;

const Employee_Key = 'Employee';
const Freelancer_key = 'Freelancer';

const DescriptionLimit = 60;
/** 0-invited, 1-accepted, 2-rejected */
const Invited_Code = 0;

const AssignTree = [
	{
		id: 2,
		name: 'Employees',
		children: [],
		disabled: false
	},
	{
		id: 4,
		name: 'Freelancers',
		children: [],
		disabled: false
	},
	{
		id: 1,
		name: 'Roles',
		children: [],
		disabled: false
	},
	{
		id: 0,
		name: 'Departments',
		children: [],
		disabled: false
	},
	{
		id: 3,
		name: 'Client',
		children: [],
		disabled: false
	},
];

export default {
	name: 'InviteesTreeSelection',
	props: {
		color: {
			type: String,
			default: '#000000'
		},
		bgColor: {
			type: String,
			default: ''
		},
		outlined: {
			type: Boolean,
			default: true
		},
		placeholder: {
			type: String,
			default: ''
		},
		organiser: {
			type: Object,
			default: null
		},
		address: {
			type: Object,
			default: null
		},
		selected: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		closeSelection: {
			type: Number,
			default: 0
		},
		kinds: {
			type: Array,
			default: () => []
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return { 
			loading: false,
			is_open: false,
			close_all: false,
			assign_items: AssignTree,
			assign_items_origin: AssignTree,
			assigned_to: this.selected,
			invitees: [],
			invitees_items: [],
			open: [],

			search_key: '',

			maxWidth: 0,
			top: 0,
			left: 0
		}
	},
	watch: {
		closeSelection() {
			this.close_all = true;
			this.search_key = '';

			AssignTree.forEach(a => {
				if (a.id === 3) {
					a.disabled = false;
				}
			});
			this.assign_items.forEach(a => {
				if (a.id === 3) {
					a.disabled = false;
				}
			});
			this.assign_items_origin.forEach(a => {
				if (a.id === 3) {
					a.disabled = false;
				}
			});
		},
		assigned_to() {
			if (this.assigned_to.length !== 0) {
				const is_number_arr = this.assigned_to.every(a => { return typeof(a) === 'string'});

				const assigned_to_key = is_number_arr ? this.assigned_to.join(): (this.assigned_to.map(a => {return a.id })).join();
				const selected_key = (this.selected.map(a => {return a.id })).join();

				if (assigned_to_key !== selected_key) {
					const list_tmp = [];
					this.assigned_to.forEach(a => { 
						if (typeof(a) === 'object') {
							list_tmp.push(a);
						} else {
							const filter_item = this.invitees_items.filter(item => { return item.id === a });
							list_tmp.push(filter_item[0]);
						}
					})

					this.$emit('assign-selected', list_tmp);
				}
			} else {
				this.$emit('assign-selected', this.assigned_to);
			}
		},
		selected() {
			this.assigned_to = this.selected;
		}
	},
	methods: {
		async inviteesQuery(key) {
			if (key.length === 0) return;

			this.is_open = false;
			this.close_all = false;
			this.invitees_items = [];
			const search_key = key.toLowerCase();

			this.invitees.forEach(invitee => {
				const name_lower_case = invitee.employee.display_name.toLowerCase();

				if (name_lower_case.includes(search_key)) {
					this.invitees_items.push(invitee);
				}
			});
		},
		async queryAssigned() {
			if (this.disabled === true) return;

			const elem = document.getElementById("assigned_tree_selection");
			const diff_bottom = this.$vuetify.breakpoint.height - elem.getBoundingClientRect().bottom;

			this.maxWidth = elem.clientWidth;

			this.top = diff_bottom >= 240 ? elem.getBoundingClientRect().bottom : (elem.getBoundingClientRect().top - 240);
			this.left = elem.getBoundingClientRect().left;

			await this.getInviteesList();
		},
		async getInviteesList() {
			this.invitees_loading = true;

			const params = [];
			params.push("allow_all=" + false);
			params.push("find_employee=" + true);
			params.push("find_freelancer=" + true);
			if (this.address) {
				params.push("find_on_abook=" + this.address.id);
			}

			let url = "/api/addressbook/email";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						const data_filter_list = this.organiser ? data.filter(d => { return d.abook_id !== this.organiser.employee.id }) : data;
						const employee = data_filter_list.filter(d => { return d.contact_id === null && d.abook_id !== null && d.info === Employee_Key });
						const employees_ids = employee.map(e => { return e.abook_id });
						data_filter_list.forEach(d => {
							if (d.contact_id === null && d.abook_id !== null && d.info === Freelancer_key && !employees_ids.includes(d.abook_id)) {
								d['is_freelancer'] = true;
							} else {
								d['is_freelancer'] = false;
							}
						});
						this.invitees = this._getAllInvitees(data_filter_list);


						const data_filter = this.organiser ? data.filter(d => { return d.abook_id !== this.organiser.employee.id }) : data;

						let employees = [];
						const employees_filter = data_filter.filter(d => { return d.contact_id === null && d.abook_id !== null && d.info === Employee_Key });
						employees = this._getAllEmployees(employees_filter);
						
						let freelancers = [];
						const employees_filter_ids = employees_filter.map(e => { return e.abook_id });
						const freelancers_filter = data_filter.filter(d => { return d.contact_id === null && d.abook_id !== null && d.info === Freelancer_key && !employees_filter_ids.includes(d.abook_id)});
						freelancers = this._getFreelancers(freelancers_filter);
						
						let roles = [];
						const roles_filter = employees_filter.filter(d => { return d.role !== null});
						roles = this._getRoles(roles_filter);

						let departments = [];
						const departments_filter = employees_filter.filter(d => { return d.department !== null });
						departments = this._getDepartments(departments_filter);

						let client = [];
						const client_filter = data_filter.filter(d => { return d.contact_id !== null });
						client = this._getClients(client_filter);

						if (this.address) {
							this.assign_items = AssignTree;
							this.assign_items_origin = AssignTree;

							this.assign_items.forEach(a => {
								if (a.id === CLIENT) {
									a['name'] = this.address.display_name;

									if (client.length === 0) {
										a['disabled'] = true;
									}
								}
							});
							this.assign_items_origin.forEach(a => {
								if (a.id === CLIENT) {
									a['name'] = this.address.display_name;

									if (client.length === 0) {
										a['disabled'] = true;
									}
								}
							});

						} else {
							this.assign_items = AssignTree.filter(a => { return a.id !== CLIENT });
							this.assign_items_origin = AssignTree.filter(a => { return a.id !== CLIENT });
						}

						this.assign_items.forEach(a => {
							if (a.id === ALLEMPLOYEES) {
								a.children = employees;
							}
							if (a.id === FREELANCER) {
								a.children = freelancers;
							}
							if (a.id === ROLES) {
								a.children = roles;
							}
							if (a.id === DEPARTMENTS) {
								a.children = departments;
							}
							if (a.id === CLIENT) {
								a.children = client;
							}
						});

						this.assign_items_origin.forEach(a => {
							if (a.id === ALLEMPLOYEES) {
								a.children = employees;
							}
							if (a.id === FREELANCER) {
								a.children = freelancers;
							}
							if (a.id === ROLES) {
								a.children = roles;
							}
							if (a.id === DEPARTMENTS) {
								a.children = departments;
							}
							if (a.id === CLIENT) {
								a.children = client;
							}
						});

						this.loading = false;
						this.is_open = true;
						this.close_all = false;
					} else {
						this.loading = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.loading = false;
					this.error_msg = e.message;
				});
		},
		_getAllInvitees(data) {
			const contact_data = data.filter(d => { return d.contact_id !== null });
			const employee_data = data.filter(d => { return d.contact_id === null && d.abook_id !== null });

			const unique_contact = [];
			const obj_contact = {};
			contact_data.forEach(d => {
				if (!obj_contact[d.contact_id]) {
					unique_contact.push(d);
					obj_contact[d.contact_id] = true;
				}
			});

			const unique_employee = [];
			const obj_employee = {};
			employee_data.forEach(d => {
				if (!obj_employee[d.abook_id]) {
					unique_employee.push(d);
					obj_employee[d.abook_id] = true;
				}
			});

			const invitees_all = [];

			unique_contact.forEach(d => {
				const name = this.formatName(d.name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const invite_obj = {
					id: `${CLIENT}_${d.contact_id}`,
					name: description,
					type: CLIENT,
					accepted: Invited_Code,
					contact: null,
					freelancer: d.is_freelancer,
					employee: {
						id:  d.contact_id,
						contact_id: d.contact_id,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};

				invitees_all.push(invite_obj);
			});

			unique_employee.forEach(d => {
				const name = this.formatName(d.name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const invite_obj = {
					id: `${d.is_freelancer ? FREELANCER : ALLEMPLOYEES}_${d.abook_id}`,
					name: description,
					type: d.is_freelancer ? FREELANCER: ALLEMPLOYEES,
					accepted: Invited_Code,
					contact: null,
					freelancer: d.is_freelancer,
					employee: {
						id: d.abook_id,
						contact_id: null,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};

				invitees_all.push(invite_obj);
			});

			return invitees_all;
		},
		_getAllEmployees(data) {
			const unique = [];
			const obj_tmp = {};

			data.forEach(d => {
				if (!obj_tmp[d.abook_id]) {
					unique.push(d);
					obj_tmp[d.abook_id] = true;
				}
			});

			const employees_all = [];
			unique.forEach(d => {
				const name = this.formatName(d.display_name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const obj = {
					id: `${ALLEMPLOYEES}_${d.abook_id}`,
					name: description,
					type: ALLEMPLOYEES,
					accepted: Invited_Code,
					contact: null,
					employee: {
						id: d.abook_id,
						contact_id: null,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};
				
				employees_all.push(obj);
			});		

			return employees_all;
		},
		_getFreelancers(data) {
			const unique = [];
			const obj_tmp = {};

			data.forEach(d => {
				if (!obj_tmp[d.abook_id]) {
					unique.push(d);
					obj_tmp[d.abook_id] = true;
				}
			});

			const freelancers_all = [];
			unique.forEach(d => {
				const name = this.formatName(d.display_name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const obj = {
					id: `${FREELANCER}_${d.abook_id}`,
					name: description,
					type: FREELANCER,
					accepted: Invited_Code,
					contact: null,
					employee: {
						id: d.abook_id,
						contact_id: null,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};
				
				freelancers_all.push(obj);
			});		

			return freelancers_all;
		},
		_getRoles(data) {
			const roles_all = [];

			const obj_tmp = {};
			data.forEach(d => {
				if (d.role && !obj_tmp[d.role.id]) {
					const obj = {
						id: d.role.id,
						name: d.role.display_name,
						children: []
					}
					roles_all.push(obj);
					obj_tmp[d.role.id] = true;
				}
			});

			data.forEach(d => {
				if (d.role) {
					const name = this.formatName(d.display_name);
					const description = name.length > DescriptionLimit
						? name.slice(0, DescriptionLimit) + '...'
						: name;

					const obj = {
						id: `${ROLES}_${d.abook_id}`,
						name: description,
						type: ROLES,
						accepted: Invited_Code,
						contact: null,
						employee: {
							id: d.abook_id,
							contact_id: null,
							code: d.code,
							display_name: description,
							email: d.email,
							send_email: true
						},
						image: `${d.uri}/image.png`,
						uri: d.uri
					};

					roles_all.forEach(role => {
						if (role.id === d.role.id) {
							const exsit_obj_arr = role.children.filter(c => { return c.id === obj.id });
							if (exsit_obj_arr.length === 0) {
								role.children.push(obj)
							}
						}
					})
				}				
			});

			return roles_all;
		},
		_getDepartments(data) {
			const departments_all = [];

			const obj_tmp = {};
			data.forEach(d => {
				if (d.department && !obj_tmp[d.department.id]) {
					const obj = {
						id: d.department.id,
						name: d.department.display_name,
						children: []
					}
					departments_all.push(obj);
					obj_tmp[d.department.id] = true;
				}
			});

			data.forEach(d => {
				if (d.department) {
					const name = this.formatName(d.display_name);
					const description = name.length > DescriptionLimit
						? name.slice(0, DescriptionLimit) + '...'
						: name;

					const obj = {
						id: `${DEPARTMENTS}_${d.abook_id}`,
						name: description,
						type: DEPARTMENTS,
						accepted: Invited_Code,
						contact: null,
						employee: {
							id: d.abook_id,
							contact_id: null,
							code: d.code,
							display_name: description,
							email: d.email,
							send_email: true
						},
						image: `${d.uri}/image.png`,
						uri: d.uri
					};
				
					departments_all.forEach(department => {
						if (department.id === d.department.id) {
							const exsit_obj_arr = department.children.filter(c => { return c.id === obj.id });
							if (exsit_obj_arr.length === 0) {
								department.children.push(obj);
							}
						}
					});
				}
			});

			return departments_all;
		},
		_getClients(data) {
			const unique = [];
			const obj_tmp = {};
			data.forEach(d => {
				if (!obj_tmp[d.contact_id]) {
					unique.push(d);
					obj_tmp[d.contact_id] = true;
				}
			});

			const clients_all = [];
			unique.forEach(d => {
				const name = this.formatName(d.name);
				const description = name.length > DescriptionLimit
					? name.slice(0, DescriptionLimit) + '...'
					: name;

				const obj = {
					id: `${CLIENT}_${d.contact_id}`,
					name: description,
					type: CLIENT,
					accepted: Invited_Code,
					contact: null,
					employee: {
						id: d.contact_id,
						contact_id: d.contact_id,
						code: d.code,
						display_name: description,
						email: d.email,
						send_email: true
					},
					image: `${d.uri}/image.png`,
					uri: d.uri
				};
				
				clients_all.push(obj);
			});

			return clients_all;
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		filter(queryText) {			
			if (queryText) {
				this.open = [];
				const searchText = queryText.toLowerCase();
				const assign_items_tmp = [];

				this.assign_items.forEach(a => {
					const children_tmp = a.children.filter(a => {
						const name = a.name.toLowerCase();
						return name.includes(searchText);
					});
					a.children = children_tmp;

					if (children_tmp.length > 0) {
						assign_items_tmp.push(a);
						this.open.push(a);
					}
				});

				this.assign_items = [];
				this.assign_items = assign_items_tmp;
			} else {
				this.assign_items = [];
				this.assign_items_origin.forEach(a => {
					const children_temp = [];
					a.children.forEach(c => {
						children_temp.push(c);
					});
					const obj = {
						id: a.id,
						name: a.name,
						children: children_temp
					};
					this.assign_items.push(obj);
				})
				
				this.assigned_to = [];
			}
		},
		onTreeviewNoteActive(notes) {
			this.assigned_to = [];
			this.assigned_to = notes;

			this.search_key = '';
		},
		remove () {
			this.search_key = '';
		}
	}
}
</script>
<style lang="scss" scoped>
.tree-container {
	position: fixed;
	z-index: 12;
	background-color: #FFFFFF;
	box-shadow: 0px 1px 1px #192A3E;

	height: 240px;
	overflow-y: auto;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.load {
	border: 2px solid #C4C4C4;
  border-top: 2px solid #192A3E;
	border-right: 2px solid #192A3E;
  border-radius: 50%;
  width: 20px;
  height: 20px;
	animation: spin 1s linear infinite;
}
.over-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.item-text {
	font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
	opacity: 0.87;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

::v-deep {
  .v-treeview-node__level {
    width: 24px;
  }
  .v-treeview-node__checkbox {
    margin-left: 0 !important;
  }
  .v-treeview--dense .v-treeview-node__root {
    min-height: 32px;
  }
}
</style>